import React from 'react';
import { Footer } from './Footer';
import { Seo } from './Seo';

// Shared layout for content/policy pages — matches the site's dark-luxury theme.
export const LegalLayout = ({ eyebrow, icon: Icon, title, intro, seo, testid, children }) => (
  <div className="min-h-screen bg-luxury-black text-white" data-testid={testid}>
    {seo && <Seo {...seo} />}
    <section className="py-16 md:py-24 px-6 md:px-12 lg:px-24 border-b border-white/5 bg-gradient-to-b from-luxury-charcoal to-luxury-black">
      <div className="max-w-3xl mx-auto text-center">
        <span className="text-xs uppercase tracking-[0.3em] text-luxury-gold font-semibold flex items-center justify-center gap-2 mb-4">
          {Icon && <Icon size={14} />} {eyebrow}
        </span>
        <h1 className="text-4xl sm:text-5xl font-serif-luxury text-white tracking-tight mb-5">{title}</h1>
        {intro && (
          <p className="max-w-2xl mx-auto text-sm md:text-base text-luxury-muted leading-relaxed font-sans-luxury">{intro}</p>
        )}
      </div>
    </section>

    <section className="py-14 md:py-20 px-6 md:px-12 lg:px-24">
      <div className="max-w-3xl mx-auto space-y-10">{children}</div>
    </section>

    <Footer />
  </div>
);

// A titled prose block used within LegalLayout.
export const LegalSection = ({ heading, children, testid }) => (
  <div data-testid={testid}>
    {heading && (
      <h2 className="text-lg md:text-xl font-serif-luxury text-luxury-goldLight mb-3 tracking-wide">{heading}</h2>
    )}
    <div className="text-sm md:text-base text-luxury-muted leading-relaxed font-sans-luxury space-y-3">{children}</div>
  </div>
);
